
import { Record, Union } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { FormState__getValidation, FormState__setValidationResponse_5219762A, FormState__startLoading, FormState_get_empty, RequestedValue$1, FormState_$reflection, RequestedValue$1_$reflection, CategoryMinimumQuantityId_$reflection, LabelId_$reflection, ClientApiResponse$1_$reflection, StorageId_$reflection } from "../../../Shared/Shared.js";
import { record_type, lambda_type, unit_type, union_type, class_type, list_type, string_type, int32_type, option_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { DTO_WriteCategoryMinimumQuantity_$reflection, DTO_WriteCategoryMinimumQuantity, CategoryMinimumQuantity_$reflection } from "../../../Shared/Category.js";
import { Storage__get_DisplayName, Storage_$reflection } from "../../../Shared/Storage.js";
import { Cmd_ofEffect, Cmd_none, Cmd_batch } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_OfPromise_either } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../../CommunicationV2.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { empty as empty_1, tryFind, contains, filter, sortBy, map, ofArray, singleton } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { ValidationOnGetRequest } from "../../../ErrorHandling.js";
import { join, concat } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { CategoryMinimumQuantityId__get_unwrap, LabelId__get_unwrap } from "../../../Shared/Shared.js";
import { addPrefix as addPrefix_1, fetchWithDecoder as fetchWithDecoder_1 } from "../../../Communication.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../../../Components/Toast.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { createObj, comparePrimitives, safeHash, equals } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { empty, singleton as singleton_1, append, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Select } from "../../../Components/Select.js";
import { map as map_1, unwrap } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { NumberInput } from "../../../Components/Input.js";
import { numberInputIntMaxValue } from "../../../Common.js";
import { ErrorAlert } from "../../../Components/Alert.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Dialog } from "../../../Components/Dialog.js";
import { Skeleton } from "../../../Components/Skeleton.js";
import { TextButton } from "../../../Components/Button.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetStorageId", "SetQuantity", "CreateMinimumQuantity", "UpdateMinimumQuantity", "MinimumQuantitySaved", "CategoryMinimumQuantitiesFetched", "StoragesFetched", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Settings.Categories.Dialogs.MinimumStockDialog.Msg", [], Msg, () => [[["Item", option_type(StorageId_$reflection())]], [["Item", option_type(int32_type)]], [], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", list_type(CategoryMinimumQuantity_$reflection())]], [["Item", list_type(Storage_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

class State extends Record {
    constructor(CategoryId, StorageId, CategoryMinimumQuantityId, SelectedStorage, Quantity, CategoryMinimumQuantities, Storages, FormState, SuccessCallback, OnClose) {
        super();
        this.CategoryId = CategoryId;
        this.StorageId = StorageId;
        this.CategoryMinimumQuantityId = CategoryMinimumQuantityId;
        this.SelectedStorage = SelectedStorage;
        this.Quantity = Quantity;
        this.CategoryMinimumQuantities = CategoryMinimumQuantities;
        this.Storages = Storages;
        this.FormState = FormState;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
    }
}

function State_$reflection() {
    return record_type("Settings.Categories.Dialogs.MinimumStockDialog.State", [], State, () => [["CategoryId", LabelId_$reflection()], ["StorageId", option_type(StorageId_$reflection())], ["CategoryMinimumQuantityId", option_type(CategoryMinimumQuantityId_$reflection())], ["SelectedStorage", option_type(StorageId_$reflection())], ["Quantity", option_type(int32_type)], ["CategoryMinimumQuantities", RequestedValue$1_$reflection(list_type(CategoryMinimumQuantity_$reflection()))], ["Storages", RequestedValue$1_$reflection(list_type(Storage_$reflection()))], ["FormState", FormState_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)]]);
}

function initNew(categoryId, successCallback, onClose) {
    return [new State(categoryId, undefined, undefined, undefined, undefined, new RequestedValue$1(0, []), new RequestedValue$1(0, []), FormState_get_empty(), successCallback, onClose), Cmd_batch(ofArray([Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(CategoryMinimumQuantity_$reflection())));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), concat("/api/categories/", LabelId__get_unwrap(categoryId), ..."/minimum-quantities"), (Item) => (new Msg(5, [Item])), (Item_1) => (new Msg(7, [Item_1]))), Cmd_OfPromise_either((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder_1(0, addPrefix_1(url_3), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_2) => {
        const pr_1 = response_2.arrayBuffer();
        return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(Storage_$reflection())));
    })))), "/api/storages", (Item_2) => (new Msg(6, [Item_2])), (Item_3) => (new Msg(7, [Item_3])))]))];
}

function initEdit(categoryId, storageId, categoryMinimumQuantityId, successCallback, onClose) {
    return [new State(categoryId, storageId, categoryMinimumQuantityId, undefined, undefined, new RequestedValue$1(0, []), new RequestedValue$1(0, []), FormState_get_empty(), successCallback, onClose), Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder_1(0, addPrefix_1(url), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(Storage_$reflection())));
    })))), "/api/storages", (Item) => (new Msg(6, [Item])), (Item_1) => (new Msg(7, [Item_1])))];
}

function update(msg, state) {
    let dto, dto_1;
    switch (msg.tag) {
        case 1:
            return [new State(state.CategoryId, state.StorageId, state.CategoryMinimumQuantityId, state.SelectedStorage, msg.fields[0], state.CategoryMinimumQuantities, state.Storages, state.FormState, state.SuccessCallback, state.OnClose), Cmd_none()];
        case 2: {
            const matchValue = state.StorageId;
            const matchValue_1 = state.Quantity;
            let matchResult, quantity, storageId_1;
            if (matchValue != null) {
                if (matchValue_1 != null) {
                    matchResult = 0;
                    quantity = matchValue_1;
                    storageId_1 = matchValue;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return [new State(state.CategoryId, state.StorageId, state.CategoryMinimumQuantityId, state.SelectedStorage, state.Quantity, state.CategoryMinimumQuantities, state.Storages, FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose), (dto = (new DTO_WriteCategoryMinimumQuantity(state.CategoryId, storageId_1, quantity)), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let url_2;
                        return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                            const pr = response.arrayBuffer();
                            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                        }, refreshOn)))(true);
                    })), [concat("/api/categories/", LabelId__get_unwrap(state.CategoryId), ..."/minimum-quantities"), toString(0, Auto_generateBoxedEncoder_437914C6(DTO_WriteCategoryMinimumQuantity_$reflection(), undefined, undefined, undefined)(dto))], (Item) => (new Msg(4, [Item])), (Item_1) => (new Msg(7, [Item_1]))))];
                default:
                    return [state, Cmd_none()];
            }
        }
        case 3: {
            const matchValue_3 = state.StorageId;
            const matchValue_4 = state.CategoryMinimumQuantityId;
            const matchValue_5 = state.Quantity;
            let matchResult_1, categoryMinimumQuantityId, quantity_1, storageId_2;
            if (matchValue_3 != null) {
                if (matchValue_4 != null) {
                    if (matchValue_5 != null) {
                        matchResult_1 = 0;
                        categoryMinimumQuantityId = matchValue_4;
                        quantity_1 = matchValue_5;
                        storageId_2 = matchValue_3;
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0:
                    return [new State(state.CategoryId, state.StorageId, state.CategoryMinimumQuantityId, state.SelectedStorage, state.Quantity, state.CategoryMinimumQuantities, state.Storages, FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose), (dto_1 = (new DTO_WriteCategoryMinimumQuantity(state.CategoryId, storageId_2, quantity_1)), Cmd_OfPromise_either((tupledArg_1) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let url_5;
                        return ((url_5 = addPrefix(tupledArg_1[0]), (refreshOn_1) => fetchWithDecoder(url_5, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg_1[1]])]), "application/json", (response_2) => {
                            const pr_1 = response_2.arrayBuffer();
                            return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), string_type));
                        }, refreshOn_1)))(true);
                    })), [concat("/api/categories/", LabelId__get_unwrap(state.CategoryId), "/minimum-quantities/", ...CategoryMinimumQuantityId__get_unwrap(categoryMinimumQuantityId)), toString(0, Auto_generateBoxedEncoder_437914C6(DTO_WriteCategoryMinimumQuantity_$reflection(), undefined, undefined, undefined)(dto_1))], (Item_2) => (new Msg(4, [Item_2])), (Item_3) => (new Msg(7, [Item_3]))))];
                default:
                    return [state, Cmd_none()];
            }
        }
        case 4: {
            const response_4 = msg.fields[0];
            if (response_4.tag === 1) {
                return [new State(state.CategoryId, state.StorageId, state.CategoryMinimumQuantityId, state.SelectedStorage, state.Quantity, state.CategoryMinimumQuantities, state.Storages, FormState__setValidationResponse_5219762A(state.FormState, response_4.fields[0]), state.SuccessCallback, state.OnClose), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.CategoryId, state.StorageId, state.CategoryMinimumQuantityId, state.SelectedStorage, state.Quantity, state.CategoryMinimumQuantities, state.Storages, FormState_get_empty(), state.SuccessCallback, state.OnClose), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })]))];
            }
        }
        case 5:
            return [new State(state.CategoryId, state.StorageId, state.CategoryMinimumQuantityId, state.SelectedStorage, state.Quantity, new RequestedValue$1(1, [msg.fields[0]]), state.Storages, state.FormState, state.SuccessCallback, state.OnClose), Cmd_none()];
        case 6:
            return [new State(state.CategoryId, state.StorageId, state.CategoryMinimumQuantityId, state.SelectedStorage, state.Quantity, state.CategoryMinimumQuantities, new RequestedValue$1(1, [msg.fields[0]]), state.FormState, state.SuccessCallback, state.OnClose), Cmd_none()];
        case 7:
            return [new State(state.CategoryId, state.StorageId, state.CategoryMinimumQuantityId, state.SelectedStorage, state.Quantity, state.CategoryMinimumQuantities, state.Storages, FormState_get_empty(), state.SuccessCallback, state.OnClose), Cmd_none()];
        default:
            return [new State(state.CategoryId, msg.fields[0], state.CategoryMinimumQuantityId, state.SelectedStorage, state.Quantity, state.CategoryMinimumQuantities, state.Storages, state.FormState, state.SuccessCallback, state.OnClose), Cmd_none()];
    }
}

function DialogBody(props) {
    let elems;
    const t = useTranslation()[0];
    const options = map((storage_1) => ({
        label: Storage__get_DisplayName(storage_1),
        value: storage_1.Id,
    }), sortBy((_arg_1) => _arg_1.Name, filter((storage) => !contains(storage.Id, map((_arg) => _arg.StorageId, props.CategoryMinimumQuantities), {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }), props.Storages), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems = toList(delay(() => {
        let Label, Value;
        return append(singleton_1(createElement(Select, (Label = t("general.storage"), (Value = tryFind((option_2) => equals(option_2.value, props.SelectedStorageId), options), {
            ComponentState: props.ComponentState,
            IsClearable: false,
            Label: unwrap(Label),
            NoOptionsMessage: "",
            OnChange: (option) => {
                props.Dispatch(new Msg(0, [map_1((_arg_2) => _arg_2.value, option)]));
            },
            Options: options,
            PlaceholderKey: "",
            TestId: "category-minimum-stock-storage-select",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "storage")),
            Value: unwrap(Value),
        })))), delay(() => {
            let Label_1, Value_1;
            return append(singleton_1(createElement(NumberInput, (Label_1 = t("general.minimum_quantity"), (Value_1 = map_1((value_3) => value_3, props.Quantity), {
                ComponentState: props.ComponentState,
                Label: unwrap(Label_1),
                MaxValue: numberInputIntMaxValue,
                OnChange: (arg_1) => {
                    props.Dispatch(new Msg(1, [map_1((value_4) => (~~value_4 | 0), arg_1)]));
                },
                TestId: "category-minimum-stock-quantity-input",
                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "minimum_quantity")),
                Value: unwrap(Value_1),
            })))), delay(() => {
                const matchValue = FormState__getValidation(props.FormState, t, "global");
                if (matchValue == null) {
                    return empty();
                }
                else {
                    return singleton_1(createElement(ErrorAlert, {
                        Label: matchValue,
                    }));
                }
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function NewMinimumStockQuantityDialog(props) {
    let Title;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => initNew(props.CategoryId, props.SuccessCallback, props.OnClose), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const t = useTranslation()[0];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    return createElement(Dialog, (Title = t("tool.update_notification_stock"), {
        Body: toList(delay(() => {
            const matchValue = state_1.CategoryMinimumQuantities;
            const matchValue_1 = state_1.Storages;
            let matchResult, categoryMinimumQuantities, storages;
            if (matchValue.tag === 0) {
                matchResult = 1;
            }
            else if (matchValue_1.tag === 0) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
                categoryMinimumQuantities = matchValue.fields[0];
                storages = matchValue_1.fields[0];
            }
            switch (matchResult) {
                case 0:
                    return singleton_1(createElement(DialogBody, {
                        CategoryMinimumQuantities: categoryMinimumQuantities,
                        ComponentState: componentState,
                        Dispatch: dispatch,
                        FormState: state_1.FormState,
                        Quantity: unwrap(state_1.Quantity),
                        SelectedStorageId: unwrap(state_1.StorageId),
                        Storages: storages,
                    }));
                default:
                    return singleton_1(createElement(Skeleton, {
                        Variant: "normal",
                    }));
            }
        })),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-minimum-stock-quantity-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.save"),
            OnClick: () => {
                dispatch(new Msg(2, []));
            },
            TestId: "save-minimum-stock-quantity-dialog-test-id",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

export function UpdateMinimumStockQuantityDialog(props) {
    let Title;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => initEdit(props.CategoryId, props.StorageId, props.CategoryMinimumQuantityId, props.SuccessCallback, props.OnClose), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    return createElement(Dialog, (Title = t("tool.update_notification_stock"), {
        Body: toList(delay(() => {
            const matchValue = state_1.Storages;
            return (matchValue.tag === 0) ? singleton_1(createElement(Skeleton, {
                Variant: "normal",
            })) : singleton_1(createElement(DialogBody, {
                CategoryMinimumQuantities: empty_1(),
                ComponentState: componentState,
                Dispatch: dispatch,
                FormState: state_1.FormState,
                Quantity: unwrap(state_1.Quantity),
                SelectedStorageId: unwrap(state_1.StorageId),
                Storages: filter((storage) => equals(storage.Id, props.StorageId), matchValue.fields[0]),
            }));
        })),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-minimum-stock-quantity-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.save"),
            OnClick: () => {
                dispatch(new Msg(3, []));
            },
            TestId: "save-minimum-stock-quantity-dialog-test-id",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

